<template>
    <div>
        <header>
            <div :class="isIOS ? 'header-container-ios' : 'header-container'" :style="impersonated ? 'background-color: darkorange' : ''">
                <div class="header-left">
                    <LogoSmis></LogoSmis>
                    <!--                    <Meniu class="showMenu"
                           :shortcutsDropdownOpen="shortcutDropdownOpen"
                           :notificationsDropdownOpen="notificationDropdownOpen"
                           :left-menu-opened="leftMenuOpened"
                           :usersDropdownOpen="userDropdownOpen"
                           @isClickedTopNav="topMenuOpened"
                    ></Meniu>
                    <BurgerMenu
                        class="showBurgerMobile"
                        :left-menu-opened="leftMenuOpened"
                        @isClickedTopNav="topMenuOpened"
                    >
                    </BurgerMenu>-->

                </div>

                <div class="header-right">
                    <div v-if="this.$route.path.includes('m3-sketch')" class="buttons top-header-btns">
                        <router-link to="/aplicatii/m3-sketch/dashboard-proiecte" class="licente-button">
                            <p>Dashboard</p>
                        </router-link>
                        <router-link to="/aplicatii/m3-sketch/licente/comanda-licenta" class="licente-button">
                            <p>Licențe</p>
                        </router-link>
                        <a href="https://www.facebook.com/groups/poc411 " target="_blank" class="whatsapp-button">
                            <p>Grup 4.1.1.</p>
<!--                            <GrupWhatsApp v-if="$route.path.includes('m3-sketch/')" :paidCompanies="paidCompanies" :openModule="openWhatsApp" class="grupWhatsApp" @closeWhatsApp="openWhatsApp = false"></GrupWhatsApp>-->
                        </a>
                        <div class="tutorial-button" @click="tutorialShows = true">
                            <p>Tutorial</p>
                        </div>
                        <a href="https://smis.ro/finantari/poc411" target="_blank" class="whatsapp-button">
                            <p>Ghid Smis®</p>
                        </a>
                        <div class="tutorial-button" :class="$route.fullPath.includes('tichete-suport') ? 'router-link-active' : ''" @click="$router.push({path: '/aplicatii/m3-sketch/tichete-suport'})">
                            <p>Deschide un tichet</p>
                        </div>
<!--                        <div class="consultant-button" :class="localCompanyPaid || availableLicenses > 0 ? 'blue-background' : 'red-background'" @click.stop="toggleConsultant()">
                            <p>Consultantul tău dedicat</p>
                            <img src="@/assets/images/M3/M3Sketch/logo-smis-buton.png">
                        </div>-->
<!--                        <PersonalConsultant v-if="$route.path.includes('m3-sketch/')" :availableLicenses="availableLicenses" :data="consultantData" :paid="localCompanyPaid" :openModule="openConsultant" class="consultantPersonal" @closeConsultant="openConsultant = false"></PersonalConsultant>-->
                    </div>
                    <!--                    <ShortcutDropdown-->
                    <!--                        :notificationsDropdownOpen="notificationDropdownOpen"-->
                    <!--                        @shortcutsDropdownOpen="notificationDropdownClose()"-->
                    <!--                    >-->
                    <!--                    </ShortcutDropdown>-->
                    <!--                    <NotificationDropdown-->
                    <!--                        :shortcutsDropdownOpen="shortcutDropdownOpen"-->
                    <!--                        @notificationsDropdownOpen="shortcutDropdownClose()"-->
                    <!--                    >-->
                    <!--                    </NotificationDropdown>-->
                    <!--                    <SmisTag tagnum="98T765"></SmisTag>-->
                    <UserIcon
                        user-name="User1"
                        role="Admin"
                        user-image="icontest"
                        :notificationsDropdownOpen="notificationDropdownOpen"
                        :shortcutsDropdownOpen="shortcutDropdownOpen"
                        @userDropdownOpen="userDropdownClose()"
                    ></UserIcon>
                    <BurgerMenu
                        class="showBurgerTablet"
                        :left-menu-opened="leftMenuOpened"
                        @isClickedTopNav="topMenuOpened"
                    >
                    </BurgerMenu>
                </div>
                <VideoTutorialPopup
                    :schimbaModal="tutorialShows"
                    tutorialName="Tutorial utilizare"
                    tutorial="https://www.youtube.com/embed/qKLj7Z-2Y3Q"
                    @hideTempModal="tutorialShows = false"
                ></VideoTutorialPopup>
            </div>
        </header>
    </div>
</template>
<script>
    // import NotificationDropdown from './components/NotificationDropdown';
    // import ShortcutDropdown from './components/ShortcutDropdown';
    import UserIcon from "./components/UserIcon";
    // import SmisTag from "./components/SmisTag";
    import LogoSmis from "./components/LogoSmis";
    // import Meniu from "./components/Meniu";
    import BurgerMenu from "./components/BurgerMenu.vue";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import VideoTutorialPopup from '@/pages/Aplicatii/M3/M3Sketch/components/VideoTutorialPopup'
    import PersonalConsultant from '@/pages/Aplicatii/M3/M3Sketch/PersonalConsultant'
    import GrupWhatsApp from '@/pages/Aplicatii/M3/M3Sketch/GrupWhatsApp'
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import { isIOS } from 'mobile-device-detect';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faWhatsappSquare} from '@fortawesome/free-brands-svg-icons'
    import {faShoppingCart, faThList, faQuestion} from '@fortawesome/free-solid-svg-icons'
    /*import _ from "lodash";*/
    library.add(faWhatsappSquare, faShoppingCart, faThList, faQuestion)
    var companyPaid = false;
    export default {
        components: {
            // NotificationDropdown,
            // ShortcutDropdown,
            VideoTutorialPopup,
            UserIcon,
            isIOS,
            // SmisTag,
            LogoSmis,
            FontAwesomeIcon,
            PersonalConsultant,
            GrupWhatsApp,
            // Meniu,
            BurgerMenu,
        },
        props:{
            leftMenuOpened:Boolean,
            consultantData:null,
            paidCompanies: null,
            availableLicenses: null,
            selectedPaid: null,
        },
        data() {
            return {
                topMenuOpenedVal: false,
                notificationDropdownOpen:false,
                shortcutDropdownOpen:false,
                userDropdownOpen:false,
                tutorialShows: false,
                openConsultant: false,
                openWhatsApp: false,
                consultant: null,
                impersonated: false,
                isIOS: isIOS,
                localCompanyPaid: false
            }
        },
        watch: {
            selectedPaid: {
                handler: async function(value) {
                    await value.then(function(val) {
                        if(val !== null) {
                            companyPaid = val
                        }
                    })
                    if(companyPaid !== null){
                        this.localCompanyPaid = companyPaid
                    }
                },
                deep: true
            }
        },
        mounted() {
            axios.get(api.API_ENDPOINTS.checkImpersonate)
                .then(response => {
                    this.impersonated = response.data;
                    let wasImpersonated = JSON.parse(localStorage.getItem('impersonated'));
                    if(this.impersonated && JSON.parse(localStorage.getItem('currentM3Company') && !wasImpersonated)){
                        localStorage.removeItem('currentM3Company')
                    }
                    this.$store.dispatch('auth/getUserData');

                    localStorage.setItem('impersonated', JSON.stringify(this.impersonated));
                })
        },
        methods:{
            shortcutDropdownClose(){
                this.notificationDropdownOpen=true;
                this.shortcutDropdownOpen = false;
                this.topMenuOpenedVal=false;
                this.userDropdownOpen=false;
            },
            notificationDropdownClose(){
                this.shortcutDropdownOpen=true;
                this.notificationDropdownOpen = false;
                this.topMenuOpenedVal=false;
                this.userDropdownOpen=false;
            },
            topMenuOpened(){
                this.topMenuOpenedVal=true;
                this.notificationDropdownOpen=false
                this.shortcutDropdownOpen = false;
                this.userDropdownOpen=false;
                this.$emit('topMenuOpened',this.topMenuOpenedVal);
                //this.closeLeftMenu();
            },
            userDropdownClose(){
                this.notificationDropdownOpen=false;
                this.shortcutDropdownOpen = false;
                this.topMenuOpenedVal=false;
                this.userDropdownOpen=true;

            },
            toggleConsultant() {
                this.openConsultant = !this.openConsultant
                this.openWhatsApp = false
            },
            toggleWhatsApp() {
                this.openWhatsApp = !this.openWhatsApp
                this.openConsultant = false
            },

        // closeLeftMenu(){
        //     let leftMenu = document.getElementById('leftSecond');
        //     leftMenu.classList.add('hideElement');
        //     let topMenu = document.getElementsByClassName('dropdown-menu')[0];
        //     topMenu.classList.remove('hideElement');
        // }
        }
    };
</script>
<style scoped>
.top-header-btns {
    min-height: 64px;
}
.buttons{
    position: relative;
}
.top-header-btns .router-link-active{
    background-color: #49cda8 !important;
}
.top-header-btns .router-link-active p {
    color: #fff;
    font-weight: 600;
}
.consultantPersonal{
    position: absolute;
    top: calc(100% + 7px);
    max-width: 290px;
    right: 15px;
    width: 100%;
    z-index: 999999999;
}
.grupWhatsApp{
    position: absolute;
    top: calc(100% + 7px);
    right: 0;
    width: 100%;
    z-index: 999999999;
}
.whatsapp-button{
    position: relative;
}
.licente-button{
    position: relative;
    text-decoration: none;
}
.header-container {
    flex-direction: row;
    align-items: center;
    position: relative;
    justify-content: space-between;
    width: 100%;
    min-height: 64px;
}
header {
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    margin-left: auto;
    margin-right: auto;
    background: #fff;
    min-height: 64px;
}
/*.header-right,*/
/*.header-left,*/
/*.header-container {*/
/*  display: flex;*/
/*display: -webkit-flex;*/
/*}*/
.header-left{
    min-height: 64px;
    height: 100%;
    position: absolute;
}
.showBurgerMobile{
    display: none;
}
.showBurgerTablet{
    display: none;
}
.buttons{
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
}
.consultant-button, .tutorial-button, .whatsapp-button, .licente-button{
    display: flex;
    align-items: center;
    padding: 5px 20px;
    margin-bottom: -1px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    cursor: pointer;
    transition: 0.4s;
    min-height: 30px;
}
.tutorial-button p{
    margin-bottom: 1px;
}
.tutorial-button:hover{
    text-decoration: none;
}

.tutorial-button:hover{
    background: #49cda8;
}
.tutorial-button{
    background: #e5e5e5;
    margin-right: 15px;
}
.tutorial-button svg{
    color: #fff;
}
.consultant-button{
    justify-content: center;
    margin-right: 15px;
    max-width: 290px;
    width: 290px;
}
.whatsapp-button, .licente-button{
    margin-right: 15px;
}
.whatsapp-button p, .licente-button p{
    color: #72788b;
    font-size: 13px;
    font-weight: 500;
}
.licente-button:hover{
    text-decoration: none;
}
.whatsapp-button svg, .licente-button svg{
    color: #fff;
}
.licente-button svg{
    font-size: 14px;
}
.red-background{
    background: linear-gradient(to top, #f78a9e, #fe988b) !important;
}
.blue-background{
    background: linear-gradient(to bottom, #01e9bd -26%, #007cde 83%) !important;
}
.consultant-button img{
    padding-bottom: 3px;
}
.whatsapp-button p, .tutorial-button p, .consultant-button p{
    color: #72788b;
    font-size: 13px;
    font-weight: 500;
    text-align: unset;
    text-decoration: none;
}
.whatsapp-button:hover p, .tutorial-button:hover p, .consultant-button:hover p{
	color: #fff;
}
a{
    text-decoration: none !important;
}
.header-right{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    min-height: 65px;
}
.top-header-btns a,
.top-header-btns .whatsapp-button {
    background-color: #e5e5e5!important;
}
.top-header-btns a:hover,
.top-header-btns .whatsapp-button:hover{
    background-color:#49cda8!important;
}
.top-header-btns a:hover p,
.top-header-btns .whatsapp-button:hover p{
	color: #fff;
}
@media screen and (max-width: 1630px){
    .tutorial-button,
    .consultant-button,
    .whatsapp-button,
    .licente-button{
        padding: 5px 10px;
        margin-right: 5px;
    }
    .tutorial-button p,
    .consultant-button p,
    .whatsapp-button p,
    .licente-button p{
        font-size: 11px;
    }
    .consultantPersonal{
        right: 4px !important;
    }
}
@media (max-width:900px) and (min-width:540px) {
    .showMenu{
        display: none;
    }
    .showBurgerTablet{
        display: block;
    }

}

@media (max-width:540px){
    .showMenu{
        display: none;
    }
    .showBurgerMobile{
        display: block;
    }
    .header-left{
        justify-content: space-between;
        padding:0.5rem 0;
    }
}
</style>
